import { Box } from '@mui/material';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import AppHeader from '../../components/navBar/AppHeader';
import { HeaderSlotProvider } from '../../components/navBar/HeaderSlotContext';
import MWXNavBar from '../../components/navBar/MWXNavBar';

export const Route = createFileRoute('/_authenticated/_navbar')({
  component: NavbarLayout,
});

function NavbarLayout() {
  // Released flag: always true, so the false branch is dead code.
  const compactHeader: boolean = true;

  if (compactHeader) {
    return (
      <HeaderSlotProvider>
        <AppHeader />
        <Outlet />
      </HeaderSlotProvider>
    );
  }

  return (
    <Box>
      <MWXNavBar />
      <Outlet />
    </Box>
  );
}
